import { Dependency } from '@models';

export interface RepositoriesDependenciesVulnerabilitiesResult {
  repositoriesDependenciesVulnerabilities: Dependency[];
}
